import { Dispatch } from 'react';
import {
  DELETE_CLASSIFIER,
  GET_CLASSIFIER,
  GET_CLASSIFIER_LIST,
  POST_CLASSIFIER,
  PUT_CLASSIFIER
} from '../types/classifier.types';
import { AdminApi } from '../../../api/api.apiclient';
import { ClassifierListFilters, ClassifierModel, EditClassifierRequest } from '../../../api/admin/admin.types';
import { PageRequest } from '../../../api/api.types';

export const getClassifierList = (filters?: ClassifierListFilters, pageRequest?: PageRequest) => async (dispatch: Dispatch<any>) => {
  const response = await AdminApi.Classifiers.listAllClassifiers(filters, pageRequest);

  dispatch({
    type: GET_CLASSIFIER_LIST,
    payload: {
      page: response.data
    }
  });
};

export const getClassifier = (code: string) => async (dispatch: Dispatch<any>) => {
  try {
    const response = await AdminApi.Classifiers.getOneClassifier(code);

    dispatch({
      type: GET_CLASSIFIER,
      payload: {
        selectedClassifier: response.data
      }
    });
  } catch (e) {
    dispatch({
      type: GET_CLASSIFIER,
      payload: {
        selectedClassifier: null
      }
    });
  }
};

export const addNewClassifier = (request: ClassifierModel) => async (dispatch: Dispatch<any>) => {
  const response = await AdminApi.Classifiers.addNewClassifier(request);

  dispatch({
    type: POST_CLASSIFIER,
    payload: {
      success: true,
      newClassifier: response.data
    }
  });
};

export const deleteClassifier = (code: string) => async (dispatch: Dispatch<any>) => {
  await AdminApi.Classifiers.deleteClassifier(code);
  dispatch({
    type: DELETE_CLASSIFIER,
    payload: {
      success: true
    }
  });
};

export const editClassifier = (code: string, request: EditClassifierRequest) => async (dispatch: Dispatch<any>) => {
  const response = await AdminApi.Classifiers.editClassifier(code, request);

  dispatch({
    type: PUT_CLASSIFIER,
    payload: {
      selectedClassifier: response.data
    }
  });
};
